/**
 * A struct value is a map between keys in a struct and their field values.
 */
export class StructValue {
    /** @internal */ fieldValues = {};
    /**
     * Gets the result struct value object
     */
    value = {};
    /**
     * Sets a `StructFieldValue` for `key`
     *
     * @param key The field name
     * @param value The associated `StructFieldValue`
     */
    set(key, value) {
        this.fieldValues[key] = value;
        Object.defineProperty(this.value, key, {
            configurable: true,
            enumerable: true,
            get() { return value.get(); },
            set(v) { value.set(v); },
        });
    }
    /**
     * Gets the `StructFieldValue` for `key`
     *
     * @param key The field name
     */
    get(key) {
        return this.fieldValues[key];
    }
}
//# sourceMappingURL=struct-value.js.map